import { SearchIcon } from 'lucide-react'
import { ChangeEventHandler } from 'react'
import { cn } from '@/ui/utils/style'

interface SearchInputProps {
  value: string
  placeholder: string
  autoFocus?: boolean
  className?: string
  onChange: ChangeEventHandler<HTMLInputElement>
}

export function SearchInputEuler({ value, placeholder, autoFocus, className, onChange }: SearchInputProps) {
  return (
    <div
      className={cn(
        'flex h-11 w-[197px] flex-row items-center gap-2.5 rounded-lg border border-white/5 bg-[#19191B] px-3',
        className,
      )}
    >
      <SearchIcon className="h-5 w-5 shrink-0 text-muted-foreground" />
      <input
        type="text"
        placeholder={placeholder}
        className="h-full w-full flex-1 bg-transparent text-foreground text-sm placeholder:text-muted-foreground focus:outline-none"
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
      />
    </div>
  )
}
